export const buttonStyles = {
  enabled: {
    padding: '14px 32px',
    backgroundColor: '#2e7d32',
    color: 'white',
    border: 'none',
    borderRadius: '0',
    cursor: 'pointer',
    fontSize: '16px',
    fontWeight: '500',
    width: '100%',
    maxWidth: '300px'
  },
  disabled: {
    padding: '14px 32px',
    backgroundColor: '#9e9e9e',
    color: 'white',
    border: 'none',
    borderRadius: '0',
    cursor: 'not-allowed',
    fontSize: '16px',
    fontWeight: '500',
    width: '100%',
    maxWidth: '300px'
  }
};

export const sectionStyles = {
  container: {
    marginTop: '24px'
  },
  card: {
    marginBottom: '32px',
    paddingBottom: '32px',
    borderBottom: '1px solid #e0e0e0'
  },
  title: {
    fontSize: '20px',
    fontWeight: '600',
    marginBottom: '12px',
    color: '#333'
  },
  description: {
    fontSize: '14px',
    color: '#666',
    marginBottom: '16px',
    lineHeight: '1.5'
  },
  infoMessage: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '12px 16px',
    backgroundColor: '#fff3e0',
    borderRadius: '4px',
    marginBottom: '16px',
    gap: '12px'
  },
  infoMessageSuccess: {
    display: 'flex',
    alignItems: 'flex-start',
    padding: '12px 16px',
    backgroundColor: '#e8f5e9',
    borderRadius: '4px',
    marginBottom: '16px',
    gap: '12px'
  },
  infoIcon: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: '#ff9800',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    flexShrink: 0
  },
  infoIconSuccess: {
    width: '24px',
    height: '24px',
    borderRadius: '50%',
    backgroundColor: '#2e7d32',
    color: 'white',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    fontSize: '14px',
    fontWeight: 'bold',
    flexShrink: 0
  },
  infoText: {
    color: '#e65100',
    fontSize: '14px',
    lineHeight: '1.5'
  },
  infoTextSuccess: {
    color: '#2e7d32',
    fontSize: '14px',
    lineHeight: '1.5'
  }
};
